import Class from './news-monitor';
import './news-monitor@';

export default Class;